import {Navigate, Route, Routes, useLocation} from 'react-router-dom';
import EEProExternalLoginForm from './features/common/ee-pro/components/EEProExternalLoginForm';
import {
    ChangePasswordForm,
    CreateAccountForm,
    ForgotPasswordForm,
    ForgotPasswordQuestionForm,
    LoginCompanySelectorForm,
    LoginForm
} from './features/common';
import {SingleCard} from './layouts';

export default function UnauthenticatedContent() {
    return (
        <Routes>
            <Route
                path='/login'
                element={
                    <SingleCard title='Welcome to Sage Sync' description='Sign in using your credentials'>
                        <LoginForm/>
                    </SingleCard>
                }
            />
            <Route
                path='/company-selector'
                element={
                    <SingleCard>
                        <LoginCompanySelectorForm/>
                    </SingleCard>
                }
            />
            <Route
                path='/create-account'
                element={
                    <SingleCard title="Sign Up">
                        <CreateAccountForm/>
                    </SingleCard>
                }
            />
            <Route
                path='/forgot-password'
                element={
                    <SingleCard
                        title="Forgot Password"
                    >
                        <ForgotPasswordForm/>
                    </SingleCard>
                }
            />
            <Route
                path='/forgot-password-question'
                element={
                    <SingleCard
                        title="Forgot Password"
                    >
                        <ForgotPasswordQuestionForm/>
                    </SingleCard>
                }
            />
            <Route
                path='/change-password/:token'
                element={
                    <SingleCard title="Change Password">
                        <ChangePasswordForm/>
                    </SingleCard>
                }
            />
            <Route
                path='/external-login/eepro/:quoteId/:token'
                element={
                    <SingleCard title="External Login">
                        <EEProExternalLoginForm/>
                    </SingleCard>
                }
            />
            <Route
                path='/expired-password/:token'
                element={
                    <SingleCard title="Change Password" description="Your password has expired. Please change it.">
                        <ChangePasswordForm/>
                    </SingleCard>
                }
            />
            <Route
                path='/first-login-password/:token'
                element={
                    <SingleCard title="Change Password" description="Please change your password.">
                        <ChangePasswordForm/>
                    </SingleCard>
                }
            />
            <Route path='*' element={<Navigate to={'/login'} state={{prevLocation: useLocation().pathname}}/>}></Route>
        </Routes>
    );
}
